import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PCScreen } from 'components/guide/PCScreen';
import { ReverseButton } from 'elements/eventView/atomic/ReverseButton';
import { motion } from 'framer-motion';
import { AnimTap, EColors2, EFonts } from 'libs/styles/styling';
import { useContext } from 'react';
import { useNavigate } from 'react-router';
import { GlobalContext } from 'session/state/context';
import { setLoggedUser } from 'session/state/user/userActions';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    hideRight?: boolean;
    className?: string;
}

export const AdminHeader = (props: Props) => {
    const globalContext = useContext(GlobalContext);
    const user = globalContext.state.loggedUser;
    const navigate = useNavigate();

    function logout() {
        globalContext.dispatch(setLoggedUser(null));
        navigate('/');
    }

    return (
        <S_AdminHeader className={props.className}>
            <S_PCScreen>
                <S_Logo
                    src={
                        'https://dvtqxks0zalev.cloudfront.net/b61d9edf-7352-454a-bb12-ee5b677562c5.png'
                    }
                    onClick={() => {
                        navigate('/admin');
                    }}
                    {...AnimTap}
                />
                {/* {user && user.userId === 'visit-oslo' && (
                    <S_MenuItem
                        onClick={() => {
                            navigate('/admin/integration');
                        }}
                    >
                        <S_Icon icon={['far', 'gears']} /> Integration
                    </S_MenuItem>
                )} */}
                {!props.hideRight && (
                    <S_Right>
                        {globalContext.state.loggedUserChecked && (
                            <>
                                {user && (
                                    <S_ProfileName>
                                        <S_Icon icon={['far', 'user']} />
                                        <S_Profile>{user.email ?? user.userId}</S_Profile>
                                        <S_Out onClick={logout}>({Localization.LOG_OUT})</S_Out>
                                    </S_ProfileName>
                                )}
                                {!user && (
                                    <ReverseButton
                                        iconName="right-to-bracket"
                                        text={Localization.LOGIN}
                                        onClick={() => {
                                            navigate('/login');
                                        }}
                                    />
                                )}
                            </>
                        )}
                    </S_Right>
                )}
            </S_PCScreen>
        </S_AdminHeader>
    );
};

const S_AdminHeader = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;
    display: flex;
    height: 80px;
    background: #fff;
    box-shadow: 9.002px 9.002px 45.012px 0px rgba(0, 0, 0, 0.1);
    align-items: center;
`;

const S_Logo = styled(motion.img)`
    display: flex;
    cursor: pointer;
    margin: 0 35px 0 0;
    height: 25px;
`;

const S_PCScreen = styled(PCScreen)`
    gap: 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
`;

const S_ProfileName = styled.div`
    color: ${EColors2.DARK};
    padding: 0px 10px 0 0;
    display: flex;
    align-items: center;
`;

const S_Icon = styled(FontAwesomeIcon)`
    font-size: 16px;
    color: ${EColors2.DARK};
    margin: 0 10px 0 0;
    flex-shrink: 0;
`;

const S_Profile = styled.span`
    font-size: 18px;
    font-family: ${EFonts.Medium};
    text-decoration: none;
    margin: 0 12px 0 0;
`;

const S_Out = styled.span`
    font-size: 16px;
    font-family: ${EFonts.Regular};
    cursor: pointer;
    &:hover {
        text-decoration: underline;
    }
`;

const S_Right = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: auto;
`;

// const S_MenuItem = styled.div`
//     margin-right: 15px;
//     cursor: pointer;
// `;
